import { createSelector } from 'reselect';

import { isNullOrUndefined } from '@utils/object';
import getCartAddressId from './getCartAddressId';

const getCartHasAddressId = createSelector(
  getCartAddressId,
  id => !isNullOrUndefined(id) && id !== 0,
);

export default getCartHasAddressId;
